// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as HeaderVm$PorterinFeature from "../vm/HeaderVm.mjs";
import * as LinksCmp$PorterinFeature from "../../../../ui/components/LinksCmp.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as HeaderHelper$PorterinFeature from "../../domain/helper/HeaderHelper.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../containers/login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as MobileMenuModuleScss from "../styles/MobileMenu.module.scss";
import * as DownloadAppStore$PorterinFeature from "../../../download-app/constants/DownloadAppStore.mjs";
import * as DownloadAppCardCmp$PorterinFeature from "../../../../containers/download-app/view/components/DownloadAppCardCmp.mjs";
import * as MobileMenuAuthSection$PorterinFeature from "./MobileMenuAuthSection.mjs";
import * as MobileMenuLogoutSection$PorterinFeature from "./MobileMenuLogoutSection.mjs";

var styles = MobileMenuModuleScss;

function MobileMenuCmp(Props) {
  var set_is_mobile_menu_open = Props.set_is_mobile_menu_open;
  var data = Props.data;
  var router = Router.useRouter();
  var locale = router.locale;
  var isDom = locale === LocaleConstants$PorterinUtils.en_IN;
  var menuLinks = HeaderVm$PorterinFeature.getMenuLinks(data.links, isDom);
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var set_user = match.set_user;
  var set_is_authenticated = match.set_is_authenticated;
  var is_authenticated = match.is_authenticated;
  var isBookingFlowEnabled = LocaleHelpers$PorterinUtils.enableMobileBookingFlow(router.locale);
  return React.createElement("div", {
              className: styles["mobile-menu-wrapper"]
            }, React.createElement("div", {
                  className: styles["mobile-menu-container"]
                }, React.createElement("div", {
                      className: styles["close-icon"],
                      onClick: (function (param) {
                          Curry._1(set_is_mobile_menu_open, (function (prev) {
                                  return !prev;
                                }));
                        })
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: data.close_icon.path,
                          height: 16.0,
                          width: 16.0,
                          quality: 100.0,
                          alt: data.close_icon.alt_text
                        })), React.createElement("div", {
                      className: styles["links-container"]
                    }, React.createElement(MobileMenuAuthSection$PorterinFeature.make, {
                          isBookingFlowEnabled: isBookingFlowEnabled,
                          is_authenticated: is_authenticated,
                          order_history: match.order_history
                        }), React.createElement(LinksCmp$PorterinFeature.make, {
                          links: menuLinks,
                          container_class: styles["primary-links"],
                          child_class: styles["primary-link"],
                          on_click: (function (param) {
                              Curry._1(set_is_mobile_menu_open, (function (prev) {
                                      return !prev;
                                    }));
                            })
                        }), React.createElement(MobileMenuLogoutSection$PorterinFeature.make, {
                          is_authenticated: is_authenticated,
                          onLogout: (function (param) {
                              HeaderHelper$PorterinFeature.logoutHandler(set_user, set_is_authenticated, set_is_mobile_menu_open);
                            })
                        })), React.createElement(DownloadAppCardCmp$PorterinFeature.make, {
                      data: DownloadAppStore$PorterinFeature.download_card_track_order,
                      image: DownloadAppStore$PorterinFeature.download_app_mobile_menu
                    })));
}

var make = MobileMenuCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
